module.exports = __webpack_public_path__ + "img/zixun2.eb3216b2.svg";